import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowRight, BookOpen, Building2, ClipboardCheck, FileText, Fingerprint, MessagesSquare, ShieldCheck, Users } from 'lucide-react';

const cards = [
  { to: '/admin/provider', label: 'Diverse Integration', description: 'Manage the provider organisation, staff access and sign-in.', icon: Building2 },
  { to: '/admin/customers', label: 'Customers', description: 'Review organisations, membership access, and act-as support.', icon: Building2 },
  { to: '/admin/verification', label: 'Verification', description: 'Review pending level authorisation decisions.', icon: ClipboardCheck },
  { to: '/admin/leads', label: 'Leads', description: 'Track incoming training and consulting requests.', icon: MessagesSquare },
  { to: '/admin/framework', label: 'Framework', description: 'Manage versioned assessment frameworks.', icon: BookOpen },
  { to: '/admin/content', label: 'Content', description: 'Edit task, prompt, resource, and SLT content banks.', icon: FileText },
  { to: '/admin/personas', label: 'Personas', description: 'Review the current persona library in the customer workspace.', icon: ShieldCheck },
  { to: '/admin/staff', label: 'Staff & access', description: 'Review provider and customer accounts safely.', icon: Users },
  { to: '/admin/audit', label: 'Audit', description: 'Search provider activity by action, customer and date.', icon: Activity },
  { to: '/admin/sso', label: 'SSO', description: 'Review provider connections and domain verification.', icon: Fingerprint },
];

export default function AdminHome() {
  return (
    <div className="space-y-5">
      <div className="rounded-xl border border-teal-200 bg-teal-50 p-5">
        <h2 className="text-lg font-semibold text-teal-950">Console overview</h2>
        <p className="mt-1 max-w-2xl text-sm text-teal-900">Choose a section to review customer access, content, support requests, or provider activity.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {cards.map(({ to, label, description, icon: Icon }) => (
          <Link key={to} to={to} className="group rounded-xl border border-border bg-card p-5 shadow-sm transition hover:border-teal-400 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2">
            <div className="flex items-start justify-between gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-teal-50 text-teal-700"><Icon className="h-5 w-5" aria-hidden="true" /></span>
              <ArrowRight className="h-4 w-4 text-muted-foreground transition group-hover:translate-x-1" aria-hidden="true" />
            </div>
            <h2 className="mt-4 font-semibold text-foreground">{label}</h2>
            <p className="mt-1 text-sm leading-6 text-muted-foreground">{description}</p>
          </Link>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">Use the Personas section to open the current persona library.</p>
    </div>
  );
}
